<template>
  <section class="app-main" :class="appMainClass">
    <Navbar />
    <div class="main-content">
      <div class="router-view-wrapper">
        <transition name="fade" mode="out-in">
          <router-view
            ref="routeView"
            class="main-page"
            :class="padClass"
          ></router-view>
        </transition>
        <AiChatEntry v-if="aiChatEnabled" />
      </div>
      <div v-if="panelVisible" class="ai-side-panel">
        <AiChatPanelBridge />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { Navbar } from '../components';
import { Vue, Component, Watch } from 'vue-property-decorator';
import AiChatEntry from '@/components/ai-chat-entry/index.vue';
import AiChatPanelBridge from '@/components/ai-chat-panel-bridge/index.vue';
import { isAiChatAvailableByRoute } from '@/utils/ai-chat/business-domain';

@Component({
  components: {
    Navbar,
    AiChatEntry,
    AiChatPanelBridge,
  },
})
export default class AppMain extends Vue {
  name = 'AppMain';
  isPad = false;
  extraClassFromChildren = '';

  get aiChat() {
    return this.$store.state.aiChat;
  }

  get panelVisible() {
    return this.aiChatEnabled && this.aiChat.visible;
  }

  get aiChatAvailable() {
    return isAiChatAvailableByRoute({
      routePath: String(this.$route.path || ''),
    });
  }

  get aiChatEnabled() {
    return this.aiChatAvailable && this.$hasPermission('PC.AIAgent.Access');
  }

  @Watch('$route.path')
  onRoutePathChange(newPath: string, oldPath: string) {
    if (!newPath || newPath === oldPath) return;
    this.$store.commit('closeAiChat');
    this.$store.commit('setAiChatContext', null);
  }

  created() {
    this.isPad = /NQ1000/gi.test(window.navigator.userAgent);
    if (!this.aiChatEnabled) {
      this.$store.commit('closeAiChat');
      this.$store.commit('setAiChatContext', null);
    }
  }

  get padClass() {
    return this.isPad ? 's-pad' : '';
  }

  get appMainClass() {
    const { extraClassFromChildren } = this;
    return `${extraClassFromChildren}`;
  }

  childrenViewUpdateMainClass(className: string) {
    this.extraClassFromChildren = className;
  }
}
</script>

<style>
.main-content {
  display: flex;
  flex: 1;
  min-height: 0;
}

.router-view-wrapper {
  position: relative;
  flex: 1;
  min-width: 0;
}

.main-page {
  display: flex;
  overflow: auto;
  min-width: 0;
  height: calc(100vh - 64px);
  flex: 1;
  flex-direction: column;
}

.main-page.s-pad {
  height: calc(100vh - 164px);
}

.ai-side-panel {
  display: flex;
  margin: 0 0 0 8px;
  width: 376px;
  height: calc(100vh - 64px);
  background: #ffffff;
  flex-direction: column;
  flex-shrink: 0;
}
</style>
